/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useTranslation } from 'react-i18next';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BarChartIcon from '@mui/icons-material/Payments';
import NoteAlt from '@mui/icons-material/NoteAlt';
import CreditCardIcon from '@mui/icons-material/Receipt';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import TableChartIcon from '@mui/icons-material/TableChart';
import CategoryIcon from '@mui/icons-material/Category';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import TableBarIcon from '@mui/icons-material/TableBar';
import Groups from '@mui/icons-material/Groups';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import AssessmentIcon from '@mui/icons-material/Assessment';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import ScienceIcon from '@mui/icons-material/Science';
import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ColorContext } from '../../ColorContext/darkContext';
import { logoutUser } from '../../services/apiService';
import './Sidebar.css';
import meline from '../../Images/meline.svg';

function Sidebar() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [openConfirm, setOpenConfirm] = useState(false);
    const handleOpenConfirm = () => setOpenConfirm(true);
    const handleCloseConfirm = () => setOpenConfirm(false);
    const [toastVisible, setToastVisible] = useState(false);
    const isStaff = JSON.parse(localStorage.getItem('is_staff'));

    const handleLogout = async () => {
        try {
            await logoutUser(false);
            navigate('/login');
        } catch (err) {
            console.error('Logout failed:', err);
            navigate('/login');
        }
    };
    const showDisabledToast = () => {
        setToastVisible(true);
        setTimeout(() => {
            setToastVisible(false);
        }, 3000);
    };
    const handleProtectedNavigation = (e, route) => {
        e.preventDefault();
        if (isStaff) {
            navigate(route);
        } else {
            showDisabledToast();
        }
    };

    return (
        <div className="sidebar">
            <div className="logo">
                <Link to="/" style={{ textDecoration: 'none' }}>
                    <h3 className="text_none">
                        <img src={meline} alt="meline logo" className="meline-logo" />
                        {t('app_title')}
                    </h3>
                </Link>
            </div>

            <div className="links">
                <ul>
                    <p className="spann">{t('main')}</p>
                    <Link to="/" style={{ textDecoration: 'none' }}>
                        <li>
                            <button
                                type="button"
                                className="sidebar-link"
                                style={{ border: '0px' }}
                            >
                                <DashboardIcon className="icon" />
                                <span>{t('dashboard')}</span>
                            </button>
                        </li>
                    </Link>

                    <p className="spann">{t('list')}</p>
                    <Link to="/UsersList" style={{ textDecoration: 'none' }}>
                        <li>
                            <button
                                type="button"
                                className="sidebar-link"
                                style={{ border: '0px' }}
                                onClick={(e) => handleProtectedNavigation(e, '/UsersList')}
                            >
                                <PersonIcon className="icon" />
                                <span>{t('users')}</span>
                            </button>
                        </li>
                    </Link>
                    <Link to="/products" style={{ textDecoration: 'none' }}>
                        <li>
                            <button
                                type="button"
                                className="sidebar-link"
                                style={{ border: '0px' }}
                            >
                                <TableChartIcon className="icon" />
                                <span>{t('products')}</span>
                            </button>
                        </li>
                    </Link>
                    <Link to="/categories" style={{ textDecoration: 'none' }}>
                        <li>
                            <button
                                type="button"
                                className="sidebar-link"
                                style={{ border: '0px' }}
                            >
                                <CategoryIcon className="icon" />
                                <span>{t('categories')}</span>
                            </button>
                        </li>
                    </Link>
                    <Link to="/invntory" style={{ textDecoration: 'none' }}>
                        <li>
                            <button
                                type="button"
                                className="sidebar-link"
                                style={{ border: '0px' }}
                                onClick={(e) => handleProtectedNavigation(e, '/invntory')}
                            >
                                <Inventory2Icon className="icon" />
                                <span>{t('invntory')}</span>
                            </button>
                        </li>
                    </Link>
                    <Link to="/Formulation" style={{ textDecoration: 'none' }}>
                        <li>
                            <button
                                type="button"
                                className="sidebar-link"
                                style={{ border: '0px' }}
                                onClick={(e) => handleProtectedNavigation(e, '/Formulation')}
                            >
                                <ScienceIcon className="icon" />
                                <span>{t('formulations')}</span>
                            </button>
                        </li>
                    </Link>
                    <Link to="/orders" style={{ textDecoration: 'none' }}>
                        <li>
                            <button
                                type="button"
                                className="sidebar-link"
                                onClick={(e) => handleProtectedNavigation(e, '/orders')}
                            >
                                <NoteAlt className="icon" />
                                <span>{t('orders')}</span>
                            </button>
                        </li>
                    </Link>
                    <Link to="/tables">
                        <li>
                            <button
                                type="button"
                                className="sidebar-link"
                                onClick={(e) => handleProtectedNavigation(e, '/tables')}
                            >
                                <TableBarIcon className="icon" />
                                <span>{t('tables')}</span>
                            </button>
                        </li>
                    </Link>
                    <p className="spann">{t('Reports')}</p>
                    <Link to="/OrdersReport" style={{ textDecoration: 'none' }}>
                        <li>
                            <button
                                type="button"
                                className="sidebar-link"
                                onClick={(e) => handleProtectedNavigation(e, '/OrdersReport')}
                            >
                                <AssessmentIcon className="icon" />
                                <span>{t('OrdersReport')}</span>
                            </button>
                        </li>
                    </Link>
                    <Link to="/SalesComparison" style={{ textDecoration: 'none' }}>
                        <li>
                            <button
                                type="button"
                                className="sidebar-link"
                                onClick={(e) => handleProtectedNavigation(e, '/SalesComparison')}
                            >
                                <QueryStatsIcon className="icon" />
                                <span>{t('SalesComparison')}</span>
                            </button>
                        </li>
                    </Link>
                    <Link to="/Finance" style={{ textDecoration: 'none' }}>
                        <li>
                            <button
                                type="button"
                                className="sidebar-link"
                                onClick={(e) => handleProtectedNavigation(e, '/Finance')}
                            >
                                <CreditCardIcon className="icon" />
                                <span>{t('transactions')}</span>
                            </button>
                        </li>
                    </Link>
                    <Link to="/Billings" style={{ textDecoration: 'none' }}>
                        <li>
                            <button
                                type="button"
                                className="sidebar-link"
                                style={{ border: '0px' }}
                            >
                                <BarChartIcon className="icon" />
                                <span>{t('billings')}</span>
                            </button>
                        </li>
                    </Link>
                    <Link to="/Customers" style={{ textDecoration: 'none' }}>
                        <li>
                            <button
                                type="button"
                                className="sidebar-link"
                                onClick={(e) => handleProtectedNavigation(e, '/Customers')}
                            >
                                <Groups className="icon" />
                                <span>{t('customers_service')}</span>
                            </button>
                        </li>
                    </Link>
                    <p className="spann">{t('settings')}</p>
                    <Link to="/Profile" style={{ textDecoration: 'none' }}>
                        <li>
                            <button
                                type="button"
                                className="sidebar-link"
                                style={{ border: '0px' }}
                            >
                                <AccountCircleIcon className="icon" />
                                <span>{t('profilee')}</span>
                            </button>
                        </li>
                    </Link>
                    <Link to="/Settings" style={{ textDecoration: 'none' }}>
                        <li>
                            <button
                                type="button"
                                className="sidebar-link"
                                style={{ border: '0px' }}
                            >
                                <SettingsRoundedIcon className="icon" />
                                <span>{t('settings')}</span>
                            </button>
                        </li>
                    </Link>

                    <li>
                        <button type="button" onClick={handleOpenConfirm} className="logout-btn">
                            <LogoutIcon className="icon" /> {t('logout')}
                        </button>
                    </li>
                </ul>
            </div>
            {toastVisible && <div className="custom-toast"> {t('feature_disabled')} </div>}

            <Dialog
                open={openConfirm}
                onClose={handleCloseConfirm}
                PaperProps={{
                    sx: { borderRadius: 3, padding: 1, textAlign: 'center' },
                }}
            >
                <DialogTitle>{t('logout_confirm')}</DialogTitle>

                <DialogActions
                    sx={{
                        justifyContent: 'center',
                        gap: 2,
                        paddingBottom: 2,
                    }}
                >
                    <Button
                        variant="outlined"
                        color="error"
                        onClick={handleCloseConfirm}
                        sx={{ minWidth: 80 }}
                    >
                        {t('no')}
                    </Button>
                    <Button
                        variant="outlined"
                        color="success"
                        onClick={() => {
                            handleCloseConfirm();
                            handleLogout();
                        }}
                        sx={{ minWidth: 80 }}
                    >
                        {t('yes')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default Sidebar;
